// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WFIVG6LF4Xgjx2A6exIl{flex-direction:column;gap:3px;display:flex}.ZLaghz3BedI5euBPh9SR{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `WFIVG6LF4Xgjx2A6exIl`,
	"headerDescription": `ZLaghz3BedI5euBPh9SR`
};
export default ___CSS_LOADER_EXPORT___;
